import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@dc-shared-web/components/shadcn/use-toast'

import {
  moveFolder,
  MoveFolderParams,
} from '@dc-shared-web/hooks/api/folder/moveFolder'
import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'

export const useMoveFolder = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()

  return useMutation(
    (mutationParams: MoveFolderParams) => moveFolder(apiClient, mutationParams),
    {
      onSuccess: async () => {
        trackEvent(FS.FOLDER_MOVED)

        await queryClient.invalidateQueries(['folders', 'list'])
        await queryClient.invalidateQueries(['projects'])
        await queryClient.invalidateQueries(['FolderForMove'])
        await queryClient.invalidateQueries(['FolderForMoveTree'])
        await queryClient.invalidateQueries(['foldersList'])

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error moving folder',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
